import React from 'react';
import { connect } from 'react-redux';
import { AADConfig } from '@virtus/common/auth/index';
import { auth, authActions, authSelectors, GlideUser, RootState } from '@virtus/common/auth/reducer';

interface ReduxProps {
  isInitialized: boolean;
  isAuthenticated: boolean;
  isValidUser: boolean;
  user: GlideUser | null;
  error: string | null;
  //id_token: string | null;
}

interface OwnProps {
  config: AADConfig;
  render: (state: AuthenticationHandlerRenderProps) => React.ReactNode;
}

interface UserDispatch {
  login: () => void;
  logout: () => void;
}

interface ReduxDispatch {
  initializeAuth: (payload: AADConfig) => void;
  //getAccessDispatch: (payload: any) => void;
}

type Dispatch = ReduxDispatch & UserDispatch;

export type AuthenticationHandlerRenderProps = {
  isAuthenticated: boolean;
  isValidUser: boolean;
  user: any;
  emailAddress: string | null;
} & UserDispatch;

export type AuthenticationHandlerProps = ReduxProps & Dispatch & OwnProps;

export class AuthenticationHandlerAdmin extends React.Component<AuthenticationHandlerProps> {
  componentDidMount() {
    this.props.initializeAuth(this.props.config);
  }

  componentDidUpdate(prevProps: AuthenticationHandlerProps) {
    if (!prevProps.isInitialized && this.props.isInitialized && !this.props.user) {
      this.props.login();
    }
    
  }

  render() {
    const { render, isInitialized, isAuthenticated, isValidUser, login, logout, user, emailAddress } = this.props;
    return (
      user && isInitialized && isValidUser && 
      render({isAuthenticated, isValidUser, user, login, logout, emailAddress })
    );
  }
}

const mapStateToProps = (state: RootState): ReduxProps => {
  let data =  {
    isInitialized: authSelectors.getStatus(state) === 'initialized',
    user: authSelectors.getUser(state),
    isValidUser: authSelectors.isValidUser(state),
    isAuthenticated: authSelectors.isAuthenticated(state),
    error: authSelectors.loginError(state),
    //id_token: authSelectors.getAccessToken(state),
    emailAddress:authSelectors.getEmailAddress(state),
  };
  return data;
};

const mapDispatchToProps: Dispatch = {
  initializeAuth: authActions.initialize,
  login: authActions.login,
  logout: authActions.logout,
  //getAccessDispatch: authActions.getAccessToken
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationHandlerAdmin);
